import { NgModule } from 'ng-metadata/core';
import { DatePickerComponent } from './date-picker.component';
import { DatePickerDropdownComponent } from './dropdown/date-picker-dropdown.component';
import { DatePickerRangeComponent } from './range/date-picker-range.component';
import { DatePickerDialogService } from './dialog/date-picker-dialog.service';

/**
 * @ngdoc module
 * @name mw.components.datePicker
 * @description
 *
 * Dialogs
 */
@NgModule({
    declarations: [
        DatePickerComponent,
        DatePickerDropdownComponent
    ],
    providers: [
        DatePickerDialogService
    ]
})
export class DatePickerModule {}



// WEBPACK FOOTER //
// ./src/lib/components/date-picker/date-picker.module.ts